import { render, staticRenderFns } from "./opc-card-cascade.vue?vue&type=template&id=870eabd6"
import script from "./opc-card-cascade.vue?vue&type=script&lang=js"
export * from "./opc-card-cascade.vue?vue&type=script&lang=js"
import style0 from "./opc-card-cascade.vue?vue&type=style&index=0&id=870eabd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports